import styled from 'styled-components'

export const GroupChatContainer = styled.div`
  color: #e0e0d0;
  margin-bottom: 5px;
  &:hover span {
    text-decoration: underline;
    cursor: pointer;
  }
`
